import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {authGuard} from "./core/auth/auth.guard";
import { appResolver } from './app.resolver';

export const routes: Routes = [
  {
    path:'',
    canActivate: [authGuard],
    data: {
      breadcrumb: 
      { 
        info: 'home'
      }
    },
    resolve: {
      appResolver
    },
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'iac',
        loadChildren: () => import('./iac/iac.module').then(m => m.IacModule),
      },
      {
        path: 'cicd',
        loadChildren: () => import('./cicd/cicd.module').then(m => m.CicdModule),
      },
      {
        path: 'finops',
        loadChildren: () => import('./finops/finops.module').then(m => m.FinOpsModule),
      }
    ]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
